/**
 * ============================================================
 * PGLP | MONTE HERMOM
 * COMPONENTE: PainelTarefas
 * VERSÃO:  1.1.0
 * ------------------------------------------------------------
 * Painel OPERACIONAL de tarefas:
 *   ✔ Lista + filtros
 *   ✔ Criar tarefa manual
 *   ✔ Agendar vistoria
 *   ✔ Concluir / reabrir
 *
 * A Linha do Tempo (histórico) fica em TimelineLaudo.jsx,
 * que é renderizada na tela principal do LAUDO.
 * ============================================================
 */

import React, { useState } from 'react';
import ListaTarefas from './ListaTarefas';
import ModalNovaTarefa from './ModalNovaTarefa';
import ModalAgendamento from './ModalAgendamento';

export default function PainelTarefas({
  codigo,
  laudoUuid = null,
  imovelId = null,
  imovelUuid = null,
  endereco = '',
  processo = '',
}) {
  const [modalNovaTarefa, setModalNovaTarefa] = useState(false);
  const [modalAgendamento, setModalAgendamento] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [toast, setToast] = useState(null);

  const recarregar = () => setRefreshKey(k => k + 1);

  const handleTarefaCriada = () => {
    setToast({ tipo: 'sucesso', msg: 'Tarefa criada' });
    recarregar();
    setTimeout(() => setToast(null), 4000);
  };

  const handleVistoriaAgendada = (resp) => {
    setToast({
      tipo: 'sucesso',
      msg: `Vistoria agendada — ${resp.tarefas_canceladas || 0} contato(s) cancelado(s)`,
    });
    recarregar();
    setTimeout(() => setToast(null), 5000);
  };

  return (
    <div className="relative w-full h-full flex flex-col">

      {toast && (
        <div
          className={`
            fixed top-6 right-6 z-[60] px-6 py-4 rounded-2xl shadow-2xl
            text-[11px] font-black uppercase tracking-wider
            ${toast.tipo === 'sucesso' ? 'bg-emerald-600 text-white' : 'bg-red-600 text-white'}
          `}
        >
          {toast.tipo === 'sucesso' ? '✓ ' : '⚠ '}
          {toast.msg}
        </div>
      )}

      <div className="flex-1 min-h-0">
        <ListaTarefas
          key={refreshKey}
          codigo={codigo}
          imovelId={imovelId}
          imovelUuid={imovelUuid}
          onNovaTarefa={() => setModalNovaTarefa(true)}
          onAgendarVistoria={imovelId ? () => setModalAgendamento(true) : null}
        />
      </div>

      <ModalNovaTarefa
        aberto={modalNovaTarefa}
        onFechar={() => setModalNovaTarefa(false)}
        onCriada={handleTarefaCriada}
        ordemId={codigo}
        laudoUuid={laudoUuid}
        imovelId={imovelId}
        imovelUuid={imovelUuid}
      />

      <ModalAgendamento
        aberto={modalAgendamento}
        onFechar={() => setModalAgendamento(false)}
        onAgendada={handleVistoriaAgendada}
        ordemId={codigo}
        imovelId={imovelId}
        laudoUuid={laudoUuid}
        imovelUuid={imovelUuid}
        enderecoInicial={endereco}
        processo={processo}
      />

    </div>
  );
}